<template>
  <div class="top-hero2">
    <div class="container">
      <!-- <div id="challange-target">hidden</div> -->

      <div
        class="grid grid-cols-1 gap-4 items-start lg:grid-cols-4 lg:gap-8 marginTop"
      >
        <menu-buyer
          class="hidden lg:block"
          @showProfile="showProfile"
          :user="user"
          @showDocs="showDocs"
          :docs="user.submissions"
          @showSearch="showSearch"
        />

        <div class="grid grid-cols-1 gap-4 lg:col-span-3">
          <div class="border-double border-4 border-gray-700 rounded-md">
            <template v-if="displayWelcome">
              <div class="bg-opacity-50 bg-black rounded-md p-2">
                <div class="card z-depth-3 pb-4" v-if="user">
                  <div>
                    <div>
                      <img
                        class="w-full object-cover"
                        src="https://homesby360.s3.amazonaws.com/bg2.jpg"
                        alt="homesby360"
                      />
                    </div>
                    <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
                      <div
                        class="-mt-12 sm:-mt-16 sm:flex sm:items-end sm:space-x-5"
                      >
                        <div class="flex">
                          <img
                            class="h-24 w-24 rounded-full ring-4 ring-white sm:h-32 sm:w-32 object-cover"
                            src="../../assets/Nicola.png"
                            alt="RealtorImage"
                          />

                          <div class="mt-12 sm:mt-16 ml-4">
                            <h1
                              class="text-lg sm:text-2xl font-bold text-gray-700 truncate"
                            >
                              Nicola Burger (Realtor) <br />
                              <!-- <button type="button" class="inline-flex items-center px-3 py-1.5 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-full text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <i class="fas fa-play-circle -ml-0.5 mr-2 h-4 w-4"></i>
                                        Watch Intro
                                      </button> -->
                            </h1>
                          </div>
                        </div>

                        <div
                          class="mt-6 sm:flex-1 sm:min-w-0 sm:flex sm:items-center sm:justify-end sm:space-x-6 sm:pb-1"
                        >
                          <div
                            class="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-y-0 sm:space-x-4"
                          >
                            <a
                              href="mailto:admin@homesby360.com?subject=New_Client_Contact"
                              type="button"
                              class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
                            >
                              <svg
                                class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                                />
                                <path
                                  d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                                />
                              </svg>
                              Message
                            </a>
                            <a
                              href="tel:+19106510743"
                              type="button"
                              class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
                            >
                              <svg
                                class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                                />
                              </svg>
                              Call
                            </a>
                          </div>
                        </div>
                      </div>

                      <p
                        class="mt-8 font-weight-light mx-auto text-xl text-center text-gray-500"
                      >
                        <span class="uppercase text-4xl">
                          Let's find your dream home together </span
                        ><br />
                        Begin by searching houses available in the market <br />
                        Then complete your profile to streamline the paperwork
                        process<br />
                        <br />
                      </p>

                      <nav
                        class="sm:flex space-x-4 space-y-2 sm:space-y-0  md:space-y-0 xl:space-y-0 lg:space-y-0 p-2 text-center justify-center mx-auto w-full bg-gray-100"
                        aria-label="Tabs"
                      >
                        <button
                          @click="displaySearch"
                          class="bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-3 px-3 font-light text-sm"
                        >
                          <span
                            ><i class="text-blue-500 fas fa-search mr-1"></i
                            >Search for Houses</span
                          >
                        </button>

                        <button
                          @click="showDocs"
                          class="bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-3 px-3 font-light text-sm"
                        >
                          <span
                            ><i class="text-red-500 far fa-file-pdf mr-1"></i>
                            Paper Work</span
                          >
                        </button>

                        <button
                          @click="showProfile"
                          class="bg-white rounded-full text-gray-700 shadow-md hover:text-gray-700 hover:shadow-lg py-3 px-3 font-light text-sm"
                        >
                          <span
                            ><i class="text-gray-600 fas fa-user mr-1"></i> Edit
                            Profile</span
                          >
                        </button>
                      </nav>

                      <!-- <div class="sm:-mt-1 profile-card-ctr">
                            <v-btn
                              @click="displaySearch"
                              class="profile-card__button button--blue text-center"
                              dark
                              ><i class="fas fa-search"></i> Search for Houses</v-btn
                            >
                            <v-btn
                              @click="showDocs"
                              class="profile-card__button button--orange text-center"
                              dark
                              > <i class="far fa-file-pdf mr-1"></i> Paper Work</v-btn
                            >

                            <v-btn
                              @click="showProfile"
                              class="profile-card__button button--silver text-center"
                              dark
                              > <i class="fas fa-user mr-1"></i> Edit Profile</v-btn
                            >

                          </div> -->
                    </div>
                  </div>
                </div>

                <div class="relative m-2">
                  <div
                    class="absolute inset-0 flex items-center"
                    aria-hidden="true"
                  >
                    <div class="w-full border-t border-indigo-800"></div>
                  </div>
                  <div class="relative flex justify-center">
                    <span class="px-2 bg-gray-800 rounded text-sm text-gray-50">
                      <i class="fas fa-angle-left mr-1"></i> Reviews
                      <i class="ml-1 fas fa-angle-right"></i>
                    </span>
                  </div>
                </div>

                <section class="bg-opacity-50 bg-gray-900 rounded-md">
                  <div
                    class="max-w-7xl mx-auto md:grid md:grid-cols-2 md:px-6 lg:px-8"
                  >
                    <div
                      class="py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 md:border-r md:border-indigo-900 lg:pr-16"
                    >
                      <blockquote class="mt-6 md:flex-grow md:flex md:flex-col">
                        <div
                          class="relative text-lg font-medium text-white md:flex-grow"
                        >
                          <svg
                            class="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-indigo-600"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                            aria-hidden="true"
                          >
                            <path
                              d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                            />
                          </svg>
                          <p class="relative">
                            Excellent communication and extremely professional
                            service from a family-owned, true to their service
                            business. The owners are great people, couldn’t
                            recommend anyone better!
                          </p>
                        </div>
                        <footer class="mt-8">
                          <div class="flex items-start">
                            <div
                              class="flex-shrink-0 inline-flex rounded-full border-2 border-gray-700"
                            >
                              <img
                                class="h-12 w-12 rounded-full"
                                :src="bgurl + 'Andrew G' + rest"
                              />
                            </div>
                            <div class="ml-4">
                              <div class="text-base font-medium text-white">
                                Andrew G.
                              </div>
                              <div
                                class="text-base font-medium text-indigo-200"
                              >
                                360 Real Estate, Client
                              </div>
                            </div>
                          </div>
                        </footer>
                      </blockquote>
                    </div>
                    <div
                      class="py-12 px-4 border-t-2 border-gray-900 sm:px-6 md:py-16 md:pr-0 md:pl-10 md:border-t-0 md:border-l lg:pl-16"
                    >
                      <blockquote class="mt-6 md:flex-grow md:flex md:flex-col">
                        <div
                          class="relative text-lg font-medium text-white md:flex-grow"
                        >
                          <svg
                            class="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-indigo-600"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                          >
                            <path
                              d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                            />
                          </svg>
                          <p class="relative">
                            Awesome experience. Sold my house in a month and
                            managed this as a rental for years. 5 star service.
                            Even completed all of required repairs for me. I did
                            not even have to attend the closing. Thanks Nicola..
                          </p>
                        </div>
                        <footer class="mt-8">
                          <div class="flex items-start">
                            <div
                              class="flex-shrink-0 inline-flex rounded-full border-2 border-gray-700"
                            >
                              <img
                                class="h-12 w-12 rounded-full"
                                :src="bgurl + 'Henry M' + rest"
                              />
                            </div>
                            <div class="ml-4">
                              <div class="text-base font-medium text-white">
                                Henry M.
                              </div>
                              <div
                                class="text-base font-medium text-indigo-200"
                              >
                                360 Real Estate, Client
                              </div>
                            </div>
                          </div>
                        </footer>
                      </blockquote>
                    </div>
                  </div>
                </section>
              </div>

              <!-- <div class="max-h-96 overflow-auto">
                            <client-reviews></client-reviews>
                        </div> -->
            </template>

            <template v-else-if="showBuyerProfile">
              <buyer-profile
                @showDashboard="showWelcome"
                @showWelcome="showDocs"
                :user="user"
              ></buyer-profile>
            </template>

            <template v-else-if="showBuyerDocument">
              <buyer-docs
                @showDashboard="showWelcome"
                :user="user"
                @update="getUser"
                @showWelcome="showProfile"
              ></buyer-docs>
            </template>

            <template v-else-if="showBuyerSearch">
              <buyer-search @showWelcome="showWelcome"></buyer-search>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  name: "Buyer-Dashboard",

  data() {
    return {
      displayWelcome: true,
      showBuyerProfile: false,
      showBuyerDocument: false,
      showBuyerSearch: false,
      bgurl: "https://ui-avatars.com/api/?name=",
      rest: "&background=ccf3ff&color=0099cc"
    };
  },

  mounted() {
    if (this.$route.params.submission) {
      this.displayWelcome = false;
      this.showBuyerDocument = true;
    }
    if (this.$route.params.openDocs) {
      this.displayWelcome = false;
      this.showBuyerDocument = true;
    }
  },

  computed: {
    user() {
      if (this.$route.params.user) {
        return this.$route.params.user;
      } else {
        return this.$store.getters.userLogin;
      }
    }
  },

  methods: {
    getUser() {
      this.$store.dispatch("getUser");
    },

    showProfile() {
      this.displayWelcome = false;
      this.showBuyerProfile = true;
      this.showBuyerDocument = false;
      this.showBuyerSearch = false;
    },

    showWelcome() {
      this.displayWelcome = true;
      this.showBuyerProfile = false;
      this.showBuyerDocument = false;
      this.showBuyerSearch = false;
    },

    showDocs() {
      this.displayWelcome = false;
      this.showBuyerProfile = false;
      this.showBuyerDocument = true;
      this.showBuyerSearch = false;
    },

    showSearch() {
      this.displayWelcome = false;
      this.showBuyerProfile = false;
      this.showBuyerDocument = false;
      this.showBuyerSearch = true;
    },

    displaySearch() {
      this.$router.push({ name: "listings" });
    }
  }
};
</script>
